import { render } from "./TheTabViewLoading.vue?vue&type=template&id=6f2351b5&ts=true"
import script from "./TheTabViewLoading.vue?vue&type=script&lang=ts"
export * from "./TheTabViewLoading.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__